import { render, staticRenderFns } from "./CollectDevice.vue?vue&type=template&id=64afb499&scoped=true&"
import script from "./CollectDevice.vue?vue&type=script&lang=js&"
export * from "./CollectDevice.vue?vue&type=script&lang=js&"
import style0 from "./CollectDevice.vue?vue&type=style&index=0&id=64afb499&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64afb499",
  null
  
)

export default component.exports